import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";
import { env } from "@/config/env";
import { UserStorage } from "@/storage/UserStorage";
import { AxiosError } from "axios";

export const initSentry = () => {
	Sentry.init({
		dsn: env.mode === "production" ? env.SENTRY_DSN : "",
		integrations: [
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
			Sentry.replayIntegration(),
		],
		beforeSend(event) {
			if (env.mode == "production") {
				return event;
			} else {
				console.log("Development Sentry event:", event);
				return null;
			}
		},
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
	});

	const tokenUser = UserStorage.getUser();
	setSentryUser(tokenUser);
};

export function captureApiError(apiName: string, error: AxiosError) {
	Sentry.withScope(scope => {
		scope.setTag("errorType", apiName);
		scope.setExtra("requestUrl", error?.config?.url);
		scope.setExtra("method", error?.config?.method);
		scope.setExtra("status", error?.response?.status);
		Sentry.captureException(error);
	});
}

export const setSentryUser = (user?: Dryp.User | null) => {
	if (user) {
		Sentry.setUser({
			id: user.id,
			username: user.name,
		});
	}
};

export const sentryErrorHandlers = {
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.warn("Uncaught error", error, errorInfo.componentStack);
	}),
	onCaughtError: Sentry.reactErrorHandler(),
	onRecoverableError: Sentry.reactErrorHandler(),
};
